// Module
var code = "<div class=\"container\"><div class=\"text-center\" ng-if=\"!vm.medications &amp;&amp; !vm.loading\"><h4 class=\"section-title\">Could not load medications</h4></div><div ng-if=\"vm.medications\"><h1 class=\"page-title\" ng-bind=\"vm.title\"></h1><p class=\"m-b-md\" ng-bind=\"vm.text\"></p><ul><li ng-repeat=\"med in vm.medications\"><a ng-href=\"{{med.page}}\" ng-bind=\"med.name\"></a></li></ul></div></div>";
// Exports
var _module_exports =code;;
var path = 'app/views/plans/medications/medications.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;